<template>
  <div>
    {{ word.words }}
    <audio ref="player">
      <source :src="audioSrc" type="audio/mp3" />
    </audio>
  </div>
</template>

<script>
import "./ewordBtn.scss";
export default {
  name: "EwordBtn",
  props: ["word", "rightWords", "autoPlay"],
  data() {
    return {
      noSound: false,
      isLoadedAudio: false,
      audioSrc: "",
      audio: null
    };
  },
  mounted() {
    this.noSound = false;
    this.getAudio();
  },
  watch: {
    word() {
      this.noSound = true;
      this.getAudio();
    },
    audioSrc() {
      if (this.audioSrc) this.audio = new Audio(this.audioSrc);
    },
    rightWords() {
      if (this.rightWords == this.word) {
        this.playButton();
      }
    }
  },
  methods: {
    getAudio() {
      this.isLoadedAudio = false;

      if (!this.word) return;
      if (this.word.order == "-") {
        this.audioSrc = require("../../assets/audio/LOSS1.mp3");
        this.noSound = false;
        this.isLoadedAudio = true;
        return;
      }
      // const { id, lang = 'arb' } = this.word;
      const { words, id, lang = "" } = this.word;
      fetch(
        `${process.env.VUE_APP_API_URL}/api/sound_file/${id
          .replaceAll(" ", "_")
          .toLowerCase()}_${localStorage.getItem("destLocale")}`
      )
        .then(async response => {
          if (response.status === 200) {
            const { sound_file } = await response.json();

            this.audioSrc = sound_file;
            this.noSound = false;
            this.isLoadedAudio = true;
          } else {
            this.noSound = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    playButton() {
      if (!this.noSound && this.isLoadedAudio) {
        // const audio = new Audio(this.audioSrc);
        if (this.autoPlay) {
          this.$store.commit("setIsPlaying", true);
          this.audio.play().then(this.$store.commit("setIsPlaying", false)).catch(this.$store.commit("setIsPlaying", false));

        };
        console.log("Play");
        // this.$refs.player.play();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// ewordBtn.vue?5da846de